import { Record } from "immutable";
import gql from "graphql-tag";

const Company = new Record({
  companyId: null,
  companyName: null,
  companyFullName: null,
  inn: null,
});

const query = gql`
  query searchClients($searchBy: SearchField!, $search: String!) {
    companies(companyName: $search) {
      companyId
      companyName
      companyFullName
      inn
    }
  }
`;

export { query };
export default Company;



// WEBPACK FOOTER //
// ./src/model/subsystems/clients/schema/Company.js